import { render } from "./SVGScrollUp.vue?vue&type=template&id=cdc5d8d0"
import script from "./SVGScrollUp.vue?vue&type=script&lang=js"
export * from "./SVGScrollUp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__